// Replacement for the Vue-2-instance event bus (`new Vue()`): same $on/$once/$off/$emit
// API so existing call sites keep working under Vue 3.
const channels = new Map()

const getChannel = (event) => {
    if (!channels.has(event)) channels.set(event, new Set())
    return channels.get(event)
}

const bus = {
    $on(event, handler) {
        if (Array.isArray(event)) {
            event.forEach((e) => bus.$on(e, handler))
            return bus
        }
        getChannel(event).add(handler)
        return bus
    },
    $once(event, handler) {
        if (Array.isArray(event)) {
            event.forEach((e) => bus.$once(e, handler))
            return bus
        }
        const once = (...args) => {
            bus.$off(event, once)
            handler(...args)
        }
        once.__original = handler
        getChannel(event).add(once)
        return bus
    },
    $off(event, handler) {
        if (Array.isArray(event)) {
            event.forEach((e) => bus.$off(e, handler))
            return bus
        }
        if (event === undefined) {
            channels.clear()
        } else if (handler === undefined) {
            channels.delete(event)
        } else {
            const channel = channels.get(event)
            channel?.forEach((h) => {
                if (h === handler || h.__original === handler) channel.delete(h)
            })
        }
        return bus
    },
    $emit(event, ...args) {
        channels.get(event)?.forEach((handler) => handler(...args))
        return bus
    },
}

export default bus
